import { render, staticRenderFns } from "./credit.vue?vue&type=template&id=6282f076&scoped=true&"
import script from "./credit.vue?vue&type=script&lang=js&"
export * from "./credit.vue?vue&type=script&lang=js&"
import style0 from "./credit.vue?vue&type=style&index=0&id=6282f076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6282f076",
  null
  
)

export default component.exports